<img
  src="./../../../../../assets/images/pin.png"
  alt="locate"
  (click)="geoLocation()"
/>
